import React from 'react';
import './UIBrand.css';
import logo from '../../../../assets/logo.webp';

export default function UIBrand() {

    return (
        <a className="ui-brand" href="/">
            <img src={logo} alt="Dorffuchs Logo" />
            <span>dorffuchs</span>
        </a>
    );
}

